import FJVoiceSetting from './FJVoiceSetting';
import useLocalStore from '../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import {
    setSliceVoiceSpeed,
    setSliceVoicePitch,
    setSliceVoiceValue,
    setSliceVoiceStyleValue,
    setSliceVoiceSettingActive,
} from '../../../redux/slices/FJSliceTextToVideo';
import { useCallback, useEffect } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
const FJVoiceSettingContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const languageList = useSelector(state => state.textToVideo.languageList);
    const languageValue = useSelector(state => state.textToVideo.languageValue);
    const voiceList = useSelector(state => state.textToVideo.voiceList);
    const voiceValue = useSelector(state => state.textToVideo.voiceValue);
    const voiceStyleList = useSelector(state => state.textToVideo.voiceStyleList);
    const voiceStyleValue = useSelector(state => state.textToVideo.voiceStyleValue);
    const voiceSpeed = useSelector(state => state.textToVideo.voiceSpeed);
    const voicePitch = useSelector(state => state.textToVideo.voicePitch);
    const voiceSettingActive = useSelector(state => state.textToVideo.voiceSettingActive);

    useEffect(() => {
        dispatch(FJActionTextToVideo.getAndSetLanguageAndVoiceListAction());
    }, [dispatch]);
    const onChangeVoice = useCallback(
        voice => {
            dispatch(setSliceVoiceValue(voice));
            dispatch(FJActionTextToVideo.updateTTSInfoByVoiceAction(voice));
        },
        [dispatch],
    );
    const onChangeVoiceStyle = useCallback(
        voiceStyle => {
            dispatch(setSliceVoiceStyleValue(voiceStyle));
        },
        [dispatch],
    );
    const onChangeVoiceSpeed = useCallback(
        voiceSpeed => {
            dispatch(setSliceVoiceSpeed(voiceSpeed));
        },
        [dispatch],
    );
    const onChangeVoicePitch = useCallback(
        voicePitch => {
            dispatch(setSliceVoicePitch(voicePitch));
        },
        [dispatch],
    );
    const onLanguageValueChange = useCallback(
        language => {
            dispatch(FJActionTextToVideo.updateTTSLanguageInfoAction(language));
        },
        [dispatch],
    );
    const stopPreview = useCallback(() => {
        dispatch(FJActionTextToVideo.stopPreviewTTSAction());
    }, [dispatch]);
    const onVoiceSettingActiveChange = useCallback(
        voiceSettingActive => {
            dispatch(setSliceVoiceSettingActive(voiceSettingActive));
        },
        [dispatch],
    );
    return (
        <FJVoiceSetting
            languageList={languageList}
            voiceList={voiceList}
            voiceValue={voiceValue}
            voiceStyleList={voiceStyleList}
            voiceStyleValue={voiceStyleValue}
            voiceSpeed={voiceSpeed}
            voicePitch={voicePitch}
            languageValue={languageValue}
            onChangeVoice={onChangeVoice}
            onChangeVoiceStyle={onChangeVoiceStyle}
            onChangeVoiceSpeed={onChangeVoiceSpeed}
            onChangeVoicePitch={onChangeVoicePitch}
            onLanguageValueChange={onLanguageValueChange}
            stopPreview={stopPreview}
            voiceSettingActive={voiceSettingActive}
            onVoiceSettingActiveChange={onVoiceSettingActiveChange}
        />
    );
};

export default FJVoiceSettingContainer;
